import { useQuery } from 'react-query'
import callAPI from '../../../API/callSecureAPI'
import endpoints from '../../../API/endpoints'
import { useAuth0 } from '../../../contexts/auth0-context'
import { useStrategy } from '../../hooks/useStrategy'

export type StrategicImperative = {
    _id: string
    name: string
    audiences?: string[]
    linkedActivities?: string[]
    linkedValueMessages?: string[]
    order?: number
    createdAt?: string
}

export const getStrategicImperativesQueryKey = (strategyId?: string) => ['strategicImperatives', strategyId]

export const useStrategicImperativesQuery = () => {
    const { getTokenSilently, isAuthenticated } = useAuth0()
    const strategyId = useStrategy()?._id

    const getStrategicImperatives = async (): Promise<StrategicImperative[]> => {
        const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
        const { url, method } = endpoints.getSIForTable
        const response = await callAPI(url + strategyId, method, token)

        if (!response.success) {
            throw new Error(response.error ?? 'Failed to load strategic imperatives')
        }

        return [...(response.data ?? [])].sort(
            (left: StrategicImperative, right: StrategicImperative) => (left.order ?? 0) - (right.order ?? 0)
        )
    }

    return useQuery(getStrategicImperativesQueryKey(strategyId), getStrategicImperatives, {
        enabled: !!getTokenSilently && !!isAuthenticated && !!strategyId,
        refetchOnWindowFocus: false,
    })
}
